"use client";


import { createBunjaStore, createReadScopeFn, createScope, delayUnmount } from "./bunja-DxIUFo_M.js";
import { createContext, createElement, use, useEffect, useMemo, useState } from "react";

//#region react.ts
const __DEV__ = process.env.NODE_ENV !== "production";
const BunjaStoreContext = createContext(createBunjaStore());
function BunjaStoreProvider({ children }) {
	const [value] = useState(createBunjaStore);
	useEffect(() => () => value.dispose(), [value]);
	return createElement(BunjaStoreContext, {
		value,
		children
	});
}
const scopeContextMap = /* @__PURE__ */ new Map();
function bindScope(scope, context) {
	scopeContextMap.set(scope, context);
}
function createScopeFromContext(context, hash) {
	const scope = createScope(hash);
	bindScope(scope, context);
	return scope;
}
const defaultReadScope = (scope) => {
	const context = scopeContextMap.get(scope);
	return use(context);
};
function useBunja(bunja, scopeValuePairs) {
	const store = use(BunjaStoreContext);
	const readScope = scopeValuePairs ? createReadScopeFn(scopeValuePairs, defaultReadScope) : defaultReadScope;
	if (__DEV__) {
		const { value, mount, deps, bunjaInstance } = store.get(bunja, readScope);
		useEffect(delayUnmount(mount), deps);
		useMemo(() => ({
			bunja,
			scopeValuePairs,
			bunjaInstance
		}), [
			bunja,
			scopeValuePairs,
			bunjaInstance
		]);
		return value;
	} else {
		const { value, mount, deps } = store.get(bunja, readScope);
		useEffect(delayUnmount(mount), deps);
		return value;
	}
}

//#endregion
export { BunjaStoreContext, BunjaStoreProvider, bindScope, createScopeFromContext, scopeContextMap, useBunja };